<template>
  <q-form class="row q-gutter-sm q-pb-xl justify-center">
    <q-banner
      v-if="!readonly && isRestricted"
      class="bg-info text-white col-12"
    >
      Cet événement n'est pas modifiable
    </q-banner>
    <autocomplete-type-mc
      v-if="allTypes"
      v-model="value.type"
      not-restricted
      label="Type"
      :readonly="vReadonly || !!value.id"
      class="col-12"
      @input="onSubmit"
    />
    <lwf-autocomplete
      v-else
      v-model="value.type"
      option-value="id"
      :options="eventTypes"
      label="Type"
      :readonly="vReadonly || !!value.id"
      class="col-12"
      @input="onSubmit"
    />
    <autocomplete-site
      v-if="value.id"
      v-model="value.site"
      class="col-12"
      :readonly="vReadonly"
      @input="onSubmit"
    />
    <time-line-events
      v-show="value.id"
      v-if="!vReadonly || value.eventMessages && value.eventMessages.length"
      :value="value.eventMessages"
      :readonly="vReadonly"
      class="col-12 col-md-6"
      @submit="onSubmitMessage"
    />
  </q-form>
</template>

<script>
import formMixin from '@/mixins/formMixin'
import LwfAutocomplete from 'components/core/LwfAutocomplete'
import TimeLineEvents from 'components/TimeLineEvents'
import { mapGetters } from 'vuex'
import { EVENTS_MAIN_TYPE_INCIDENT } from '@/consts/events'
import AutocompleteTypeMc from 'components/fields/AutocompleteTypeMc'

export default {
  name: 'FormEventsIncident',
  components: {
    AutocompleteTypeMc,
    AutocompleteSite: () => import('components/fields/AutocompleteSite'),
    TimeLineEvents,
    LwfAutocomplete
  },
  mixins: [formMixin],
  props: {
    typeIncident: {
      type: String,
      default: EVENTS_MAIN_TYPE_INCIDENT
    },
    allTypes: Boolean,
    readonly: Boolean
  },
  computed: {
    ...mapGetters({
      constServiceEventTypesKeys: 'constServiceEventTypesKeys'
    }),
    ...mapGetters({
      isRestrictedEventType: 'isRestrictedEventType'
    }),
    eventTypes () {
      return _.get(this.constServiceEventTypesKeys, [this.typeIncident, 'subTypes'], []).filter((t) => t.enabled)
    },
    isRestricted () {
      return this.isRestrictedEventType(this.value.type)
    },
    vReadonly () {
      return this.readonly || this.isRestricted
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        if (v) {
          this.handleCompanySet(v)
        }
      }
    }
  },
  methods: {
    handleCompanySet (event = {}) {
      this.$set(
        event,
        'type',
        event.type
          ? {
            ...event.type,
            ...(this.constServiceEventTypesKeys[event.type.typeKey] || {})
          }
          : null
      )
    },
    onSubmitMessage (eventMessages) {
      this.$emit('submit', {
        ...this.value,
        eventMessages
      })
    }
  }
}
</script>
